// Пути — только отсюда: строки путей в коде не пишутся (docs/architecture.md, «Маршруты»).
export const URL_HOME = "/";
export const URL_LOGIN = "/login";
export const URL_REGISTER = "/register";
export const URL_FORGOT_PASSWORD = "/forgot-password";
/** Ссылка из письма восстановления: `PASSWORD_RESET_URL` сервера указывает сюда (`?token=...`). */
export const URL_RESET_PASSWORD = "/reset-password";

export const URL_BOARDS = "/boards";
export const URL_PROFILE = "/profile";

export const urlBoard = (boardId: string | number) => `${URL_BOARDS}/${boardId}`;

/** Query-параметр с внутренним путём, куда вернуться после входа. */
export const URL_PARAM_REDIRECT = "redirect";
/** Query-параметр с токеном восстановления пароля; страница сразу убирает его из адресной строки. */
export const URL_PARAM_RESET_TOKEN = "token";
